

























// vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {State} from 'vuex-class';
import Swiper from 'swiper';

@Component({
  components: {
  },
})
export default class App extends Vue {
  @State('companyInfo')
  public companyInfo!: any;

  @Prop({
    type: Object,
    required: true,
  })
  public homeInfo!: any;

  get homeIMGs() {
    const imgNames: string[] = this.homeInfo.backImgUrl.split(',');
    const baseURL: string = this.homeInfo.urlAddr;
    const imgURL: string[] = [];

    if (imgNames.length) {
      return imgNames.map((item, index) => {
        return baseURL.concat(item);
      });
    } else {
      return imgNames;
    }
  }

  @Watch('homeInfo', {
    deep: true,
  })
  public WatchHomeInfo(value: any) {
    this.initSwiper();
  }

  // 设置swiper
  public initSwiper() {
    this.$nextTick(() => {
      const swiper = new Swiper('.swiper-container', {
        direction : 'vertical',
        loop: true,
        autoplay: {
          delay: 10000,
        },
      });
    });
  }
}
